'use client'

import { useTranslation } from '@/hooks/client/use-translation'

interface PricesSectionHeaderProps {
  hasSelectors: boolean
  sellerCount: number
  pricedName: string
}

/** The original seller-card heading, aligned with the full pricing section. */
export const PricesSectionHeader = ({ hasSelectors, sellerCount, pricedName }: PricesSectionHeaderProps) => {
  const { t } = useTranslation()
  const isSingleSeller = sellerCount === 1

  return (
    <div className="flex min-w-0 flex-wrap items-end justify-between gap-x-8 gap-y-4">
      <div>
        <h2 className="text-navy text-[24px] leading-tight font-medium lg:text-[2rem]">
          {isSingleSeller ? t('product.pricing', 'Pricing') : t('product.comparePrices', 'Compare Prices')}
        </h2>
        {!hasSelectors && (
          <p className="text-navy-60 mt-1 text-sm">
            {isSingleSeller
              ? t('product.verifiedSeller', 'Verified seller for {{name}}.', { name: pricedName })
              : t('product.verifiedSellers', '{{count}} verified sellers for {{name}}.', {
                  count: sellerCount,
                  name: pricedName,
                })}
          </p>
        )}
      </div>
    </div>
  )
}
